/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import DatePicker from '../../../components/datePicker';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/esm/Container';
import { getLocationDetails } from '../../../redux/slices/location/locationDetails';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { useLocales } from '../../../locales';
import IsLoadingIndicator from '../../../components/isLoadingIndicator';
import { newConfigsMap } from './config';
import { DEFAULT_RANGE } from '../../../components/datePicker/utils';
import {
  getAnalyticsForLocation,
  transferData
} from '../../../redux/slices/analytics/plotsData';
import { getAllDates } from '../../../utils/dateUtils';
import { INSTAGRAM } from '../../../config/constants';
import { getUserDetails } from '../../../redux/slices/user/userDetails';
import { data } from './demoDataDocument';
import NewPlotTabs from '../../../components/plotTabs/newPlotTabs';
import { ANALYICS_FOR_SOCIAL_MEDIA } from '../../../config/firebase/collections';
import PlatformHeatmapList from '../../../components/analytics/heatmapList';
import {
  ANALYTICS_NAVBAR_ACTIONS,
  BEST_TIME_TO_POST_LABEL,
  CAMPAIGN_ANALYTICS_LABEL,
  DEMOGRAPHICS_LABEL,
  GROWTH_LABEL,
  OVERVIEW_LABEL,
  POST_PERFORMANCE_LABEL
} from '../../dashboard/config';
import AnalyticsPagesLayout from '../../../components/analyticsPagesLayout';
import OverviewTab from '../shared/OverviewTab';
import BestTimeToPostTab from '../shared/BestTimeToPostTab';
import {
  fetchDemographics,
  extractDemographicsData
} from '../../../redux/slices/analytics/demographics';
import { LomavisDemographicsSectionForPlatform1 } from '@/lomavisSharedUi/templates/sections/analytics/lomavisDemographicsSectionForPlatform1';
import InstagramOverviewTab from './InstagramOverviewTab';
import InstagramBestTimeToPostTab from './InstagramBestTimeToPostTab';
import InstagramDemographicsTab from './InstagramDemographicsTab';
import PostPerformance from '@/pages/allAnalytics/sections/postPerformance';
import GrowthTab from '../shared/GrowthTab';
import CampaignAnalysis from '@/pages/allAnalytics/sections/campaignAnalytics';

const InstagramAnalyticsPage: React.FC = () => {
  const { isLoading, uuid, demo, platforms_information } = useSelector(
    (state: any) => state.locationDetails
  );
  const { data: demographicsData, isLoading: demographicsLoading } =
    useSelector((state: any) => state.demographics);

  const dispatch = useDispatch();
  const { locationslug } = useParams();
  const [error, setError] = useState(false);
  useEffect(() => {
    dispatch(getUserDetails() as unknown as AnyAction);
  }, [dispatch]);

  useEffect(() => {
    if (locationslug ?? '') {
      dispatch(getLocationDetails(locationslug) as unknown as AnyAction);
    }
  }, [dispatch, locationslug]);

  // Fetch demographics data when uuid is available
  useEffect(() => {
    if (uuid && !demo) {
      dispatch(fetchDemographics(uuid) as any);
    }
  }, [dispatch, uuid, demo]);

  const [dates, setDates] = useState({
    ...DEFAULT_RANGE
  });

  const type = 'social_media_profile';
  const [plotsData, setPlotsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [oldPlotsData, setOldPlotsData] = useState(null);
  const [loadingOld, setLoadingOld] = useState(true);
  useEffect(() => {
    // ── 1. Demo mode ───────────────────────────────────────────────────────
    if (demo) {
      setPlotsData(data);
      setLoading(false);
      setLoadingOld(false);
      return;
    }

    // ── 2. Guard clauses ───────────────────────────────────────────────────
    if (!dates) return;
    // if(demo) {setPlotsData(transferData(demo, newConfigsMap)); return;}
    if (
      !isLoading &&
      uuid &&
      Object.keys(platforms_information).includes(INSTAGRAM)
    ) {
      setLoading(true);
      setError(false);
      getAnalyticsForLocation(
        ANALYICS_FOR_SOCIAL_MEDIA,
        type,
        platforms_information[INSTAGRAM]?.[0]?.uuid,
        dates,
        INSTAGRAM
      )
        .then((res) => {
          setPlotsData(transferData(res, newConfigsMap));
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setError(true);
          setLoading(false);
        });
    }
  }, [uuid, isLoading, dates]);
  if (isLoading) return <IsLoadingIndicator />;
  console.log('platforms_information[INSTAGRAM][0]', platforms_information);
  return (
    <Container>
      <AnalyticsPagesLayout
        actions={ANALYTICS_NAVBAR_ACTIONS}
        tabs={{
          [OVERVIEW_LABEL]: (
            <InstagramOverviewTab
              dates={dates}
              setDates={setDates}
              plotsData={plotsData}
              loading={loading}
              error={error}
              newConfigsMap={newConfigsMap}
            />
          ),
          [BEST_TIME_TO_POST_LABEL]: <InstagramBestTimeToPostTab />,
          [DEMOGRAPHICS_LABEL]: <InstagramDemographicsTab />,
          [POST_PERFORMANCE_LABEL]: <PostPerformance platform={INSTAGRAM} />,
          [GROWTH_LABEL]: (
            <GrowthTab
              dates={dates}
              setDates={setDates}
              plotsData={plotsData}
              newConfigsMap={newConfigsMap}
              error={error}
              loading={loading}
              show_data_import_info={false}
              locationslug={locationslug}
            />
          ),
          [CAMPAIGN_ANALYTICS_LABEL]: <CampaignAnalysis platform={INSTAGRAM} />
        }}
      />
    </Container>
  );
};

export default InstagramAnalyticsPage;
